import AOS from 'aos';
AOS.init( {
    once: true,
    duration: 750,
    easing: 'ease-out-back',
    anchorPlacement: 'top-bottom',
} );
import 'slick-carousel';
import 'slick-lightbox';

import './template-parts/global';
import './template-parts/header';
import './template-parts/banner';
import './template-parts/ajax';
import './template-parts/homepage';
import './template-parts/single-post';
import './template-parts/single-portfolio';
import './template-parts/clients';
import './template-parts/contact-forms';
import './template-parts/project-slider';
import './template-parts/project-cards';
import './template-parts/proud-slider';
import './template-parts/team-slider';
import './template-parts/work-slider';
import './template-parts/content-slider';
import './template-parts/steps-slider';
import './template-parts/portfolio-screens-slider';
import './template-parts/cursor';
import './template-parts/what-we-offer-slider';
import './template-parts/checklist-gallery';
import './template-parts/package-checklist';
import './template-parts/media-video';
// import './template-parts/social-package-form';


window.addEventListener( 'load', () => {
    AOS.refreshHard();
} );